var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[(_vm.total)?_c('div',{staticClass:"progress-value",style:({width: _vm.width})}):_vm._e(),_vm._l((_vm.progress),function(item,index){return _c('div',{key:index,staticClass:"progress-step",class:{'is-active': item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }